import { civilities } from "../../static/types/commonTypes/individualType"
import PostalCodeField from "./PostalCodeField"
import useValidation from "../../hooks/useValidation"
import { useEffect, useState } from "react"
import headOfficeAddressValidationSchema from "../../utils/validation/headOfficeValidationSchema"
import { getCityWithPreposition } from "../../utils/functions/getCityWithPreposition"
import { IndividualWithFamilySituationType } from "../../static/types/commonTypes/individualWithFamilySituationType"
import individualWithFamilySituationVAlidationSchema from "../../utils/validation/individualWithFamilySituationValidationSchema"
import { format, isValid, parse } from "date-fns"

type IndividualWithFamilySituationProps = {
    checked: boolean,
    individual: IndividualWithFamilySituationType,
    changeIndividual: ( individual: Partial<IndividualWithFamilySituationType> ) => void,
    onValidationChange: ( isValid: boolean ) => void
}

export default function IndividualWithFamilySituation ({
    checked,
    individual,
    changeIndividual,
    onValidationChange
}: IndividualWithFamilySituationProps ) {

    const { errors, isValid: isDataValid } = useValidation( individual, individualWithFamilySituationVAlidationSchema )

    useEffect( () => {
        onValidationChange( isDataValid )
    }, [ isDataValid, onValidationChange ])

    
        const [ eventDate, setEventDate ] = useState<string>("");
    
        useEffect(() => {
            if (individual.eventDate) {
                const parsedDate = parse(individual.eventDate, "dd/MM/yyyy", new Date());
                setEventDate(isValid(parsedDate) ? format(parsedDate, "yyyy-MM-dd") : "");
            }
        }, [ individual ]);
    
        const handleActeDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            const inputDate = e.target.value;
            const parsedDate = parse(inputDate, "yyyy-MM-dd", new Date());
            const formattedDate = isValid(parsedDate) ? format(parsedDate, "dd/MM/yyyy") : "";
    
            setEventDate(inputDate);
            changeIndividual({ eventDate: formattedDate });
        };
    
        const openDatePicker = (id: string) => {
            const input = document.getElementById(id) as HTMLInputElement;
            input?.showPicker();
        };

        const eventLabel = individual.familySituation === "Pacsé"
        ? "pacs"
        : individual.familySituation === "Marié"
        ? "mariage" : "divorce"

    return(
        <div className = "mb-3 row">

                        
            <div className = "mb-3 row">

                <label htmlFor = "civility" className = "col-sm-2 col-form-label"> Civilité <strong className="text-danger">*</strong>  </label>

                <div className = "col-sm-10">

                    <select
                        className = { `form-control ${ ( checked && errors.civility ) ? 'is-invalid' : ''}` }
                        name = "civility"
                        id = "civility"
                        value = { individual.civility }
                        onChange = { event => changeIndividual({ civility: event.target.value as "Monsieur" | "Madame" } )}
                    >
                        {
                            civilities.map( option => 
                                <option key = { option } value = {option}>
                                    {option}
                                </option>
                            )
                        }

                    </select>
                    {( checked && errors.civility ) && <div className="invalid-feedback"> { errors.civility } </div> }

                </div>

            </div>
            
            <div className = "mb-3 row">

                <label htmlFor = "lastName" className = "col-sm-2 col-form-label">Nom <strong className="text-danger">*</strong> </label>

                <div className = "col-sm-10">

                    <input
                        className = { `form-control ${ ( checked && errors.lastName ) ? 'is-invalid' : ''}` }
                        type = "text"
                        name = "nom"
                        id = "lastName"
                        value = { individual.lastName }
                        onChange = { event => changeIndividual({ lastName: event.target.value })}

                    />
                    {  ( checked && errors.lastName ) && <div className="invalid-feedback"> { errors.lastName } </div> }

                </div>
            </div>

            <div className = "mb-3 row">

                <label htmlFor = "firstName" className = "col-sm-2 col-form-label">Prénom <strong className="text-danger">*</strong> </label>

                <div className = "col-sm-10">

                    <input
                        className = { `form-control ${ ( checked && errors.firstName ) ? 'is-invalid' : ''}` }
                        type = "text"
                        name = "firstName"
                        value = { individual.firstName }
                        onChange = { event => changeIndividual({ firstName: event.target.value })}
                    />
                    {  ( checked && errors.firstName ) && <div className="invalid-feedback"> { errors.firstName } </div> }

                </div>
            </div>

            <div className = "mb-3 row">

                <label htmlFor = "familySituation" className = "col-sm-2 col-form-label">Situation familiale <strong className="text-danger">*</strong> </label>

                <div className = "col-sm-10">

                    <select
                        className = { `form-select ${ ( checked && errors.familySituation ) ? 'is-invalid' : ''}` }
                        name = "familySituation"
                        id = "familySituation"
                        value = { individual.familySituation }
                        onChange = { event => changeIndividual({ familySituation: event.target.value }) }
                    >
                        {
                            [
                                "Célibataire",
                                "Pacsé",
                                "Marié",
                                "Divorcé",
                                "Veuf(ve)"
                            ].map( ( familySituation, key )  => 
                                <option key = { key } value = { familySituation }>
                                    { familySituation }
                                </option>
                            )
                        }
                    </select>
                    {( checked && errors.familySituation ) && <div className="invalid-feedback"> { errors.familySituation } </div> }

                </div>
            </div>

           {
                individual.familySituation === "Marié" &&
                <div className = "mb-3 row">

                    <label htmlFor = "maritalRegime" className = "col-sm-2 col-form-label">Régime matrimonial <strong className="text-danger">*</strong> </label>

                    <div className = "col-sm-10">
                        <select
                            className = { `form-select ${ ( checked && errors.maritalRegime ) ? 'is-invalid' : ''}` }
                            name = "maritalRegime"
                            id = "maritalRegime"
                            onChange = { event => changeIndividual({ maritalRegime: event.target.value }) }
                        >
                            {
                                [
                                    "Communauté de biens réduite aux acquêts",
                                    "Séparation de biens",
                                    "Communauté universelle",
                                    "Participation aux acquêts"
                                ].map( ( maritalRegime, key )  => 
                                    <option key = { key } value = { maritalRegime }>
                                        { maritalRegime }
                                    </option>
                                )
                            }
                        </select>
                        {( checked && errors.maritalRegime ) && <div className="invalid-feedback"> { errors.maritalRegime } </div> }

                    </div>
                    
                </div>
           }

            {
                [ "Pacsé", "Marié", "Divorcé" ].includes( individual.familySituation ) &&
                <>
                    <div className = "mb-3 row">

                        <label htmlFor="eventDate" className="col-sm-2 col-form-label"> Date du { eventLabel } </label>
            
                        <div className="col-sm-10 mb-3">
                            <input
                                className='form-control'
                                type="date"
                                id="eventDate"
                                value={eventDate}
                                onChange={handleActeDateChange}
                                onClick={() => openDatePicker("eventDate")}
                                placeholder="JJ/MM/AAAA"
                            />
                        </div>

                    </div>

                    <div className = "mb-3 row">

                        <label htmlFor = "eventPlace" className = "col-sm-2 col-form-label"> Lieu du { eventLabel } </label>

                        <div className = "col-sm-10">

                            <input
                                className = 'form-control'
                                type = "text"
                                name = "eventPlace"
                                value = { individual.eventPlace }
                                onChange = { event => changeIndividual({ eventPlace: event.target.value })}
                            />

                        </div>

                    </div>
                </>
            }


        </div>
    )
}